import { Component, OnInit, Inject } from '@angular/core';
import { AnexoCadastro } from 'src/app/models/anexo-cadastro';
import { MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-cadastrar-anexo-cadastro-modal',
  templateUrl: './cadastrar-anexo-cadastro-modal.component.html',
  styleUrls: ['./cadastrar-anexo-cadastro-modal.component.scss']
})
export class CadastrarAnexoCadastroModalComponent implements OnInit {
  anexo: AnexoCadastro = new AnexoCadastro();
  public config: PerfectScrollbarConfigInterface = {};

  constructor(public dialogRef: MatDialogRef<CadastrarAnexoCadastroModalComponent>) {}

  ngOnInit(): void {
  }

  fechar() {
    this.dialogRef.close();
  }

  salvar() {
    this.dialogRef.close(this.anexo);
  }

  onFileChanged(event) {
    this.anexo.selectedFile = event.target.files[0];
    this.anexo.arquivo = this.anexo.selectedFile.name;
  }

  excluirArquivo() {
    this.anexo = new AnexoCadastro();
  }
}
